import React, { useCallback, useRef } from 'react';
import { NodeInstance, ScheduleExpression, ScheduleExpressionSchema } from '@glueapp/graph-types';
import { GraphReducerActions, setNodeState } from '../../GraphEditor/actions';
import { z } from 'zod';
import { ScheduleInput } from './ScheduleInput';

const ScheduleNodeStateSchema = z.object({
    time: ScheduleExpressionSchema,
});

const DEFAULT_SCHEDULE: ScheduleExpression = {
    type: 'RecurringRateBasedSchedule',
    unit: 'DAY',
    value: 1,
};

interface Props {
    nodeInstance: NodeInstance;
    dispatchGraphUpdate: (action: GraphReducerActions) => void;
}

export const ScheduleEditor: React.FC<Props> = ({ nodeInstance, dispatchGraphUpdate }) => {
    const dispatchUpdateSchedule = useCallback(
        (schedule: ScheduleExpression) => dispatchGraphUpdate(setNodeState(nodeInstance.id, { time: schedule } as any)),
        [dispatchGraphUpdate, nodeInstance.id],
    );

    const result = ScheduleNodeStateSchema.safeParse(nodeInstance.state);
    const schedule = result.success ? result.data.time : DEFAULT_SCHEDULE;

    // Persist the default on first render if state was invalid
    const initializedRef = useRef(false);
    if (!result.success && !initializedRef.current) {
        initializedRef.current = true;
        dispatchUpdateSchedule(DEFAULT_SCHEDULE);
    }

    return (
        <div className="flex flex-col gap-2 pb-4">
            <label className="text-xs font-medium text-muted-foreground">Schedule</label>
            <ScheduleInput value={schedule} onChange={dispatchUpdateSchedule} />
        </div>
    );
};
